import { AfterContentInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { EnumActionsPermissions } from '@models/EnumPermissions';

@Component({
    selector: 'configurations-entity',
    templateUrl: './entity.component.html',
    styleUrls: ['./entity.component.scss'],
})
export class EntityConfigurationsComponent implements OnInit, OnChanges {

    @Input('data') Data: any[] = [];
    public EnumActionsPermissions = EnumActionsPermissions;

    SelectedTable: string = '';

    constructor() { }

    ngOnInit() {  }

    ngOnChanges(): void {

        if (this.Data?.length > 0)
            this.SelectedTable = this.Data[0]?.ConfigTableName;


        console.log(this.SelectedTable);
    }

    OnChangeStep(ev: any) {

        this.SelectedTable = ev?.detail?.value;

        console.log(this.SelectedTable);

    }
}
